module.exports = __webpack_public_path__ + "static/21-09-28_11-49-51_3FCA-a72d726b31de86036a4b3a0d48bdd254.jpg";